export default __webpack_public_path__ + "static/media/ss.97c89cce.svg";